(() => {
  const initializePopularSearches = (root = document) => {
    root
      .querySelectorAll('.ct-header-search predictive-search')
      .forEach((predictiveSearch) => {
        if (predictiveSearch.dataset.ctPopularReady === 'true') return;

        const input = predictiveSearch.querySelector(
          'input[type="search"]'
        );
        const results = predictiveSearch.querySelector(
          '[data-predictive-search]'
        );
        const template = predictiveSearch.querySelector(
          '[data-ct-popular-search-template]'
        );

        if (!input || !results || !template) return;

        predictiveSearch.dataset.ctPopularReady = 'true';

        const openPopularSearches = () => {
          if (input.value.trim() !== '') return;

          results.innerHTML = template.innerHTML;
          predictiveSearch.setAttribute('results', 'true');

          if (typeof predictiveSearch.open === 'function') {
            predictiveSearch.open();
          } else {
            predictiveSearch.setAttribute('open', 'true');
            input.setAttribute('aria-expanded', 'true');
          }
        };

        input.addEventListener('focus', openPopularSearches);

        input.addEventListener('input', () => {
          if (input.value.trim() === '') {
            window.setTimeout(openPopularSearches, 0);
          }
        });
      });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initializePopularSearches();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializePopularSearches(event.target);
  });
})();